/**
 * Parse a flexible response that could be either JSON or plain text.
 *
 * Procore API endpoints sometimes return plain strings, sometimes JSON objects.
 * This utility attempts JSON parsing first, falling back to trimmed string.
 *
 * @param raw - Raw response text from API
 * @returns Parsed JSON object of type T, or trimmed string if parsing fails
 */
export function parseFlexibleResponse<T>(raw: string): T | string {
    try {
        return JSON.parse(raw) as T;
    } catch {
        return raw.trim();
    }
}
